import { isBrowser } from '@okapi/dom-utils';
import { GlobalRouter } from './GlobalRouter';
/**
 * Возвращает обьект глобального роутера
 * Для браузера всегда синглтон
 */
export function getGlobalRouter() {
    if (isBrowser()) {
        if (!window.globalRouter) {
            window.globalRouter = new GlobalRouter();
        }
        return window.globalRouter;
    }
    return new GlobalRouter();
}
